// extracted by mini-css-extract-plugin
export default {"root":"jiQFc","ZoomButtons":"crKZR","ZoomButton":"u75NN","ZoomInButton":"kWCY5","ZoomOutButton":"r24Pa","tooltip":"ZSPrw","ZoomDebugger":"O4_7L"};